import { Card, Stack, Typography, Box } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { useTheme } from '@mui/material/styles';

export default function SearchNotFoundCard() {
  const theme = useTheme();

  return (
    <Card
      sx={{
        width: '100%',
        maxWidth: '500px',
        alignSelf: 'center',
        marginTop: '4em !important',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        borderRadius: '16px',
        border: `1px solid ${theme.palette.grey[200]}`,
        background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)'
      }}>
      <Stack spacing={3} alignItems="center" justifyContent="center" sx={{ padding: '3em 2em' }}>
        <Box
          sx={{
            background: `linear-gradient(135deg, ${theme.palette.grey[100]} 0%, ${theme.palette.grey[200]} 100%)`,
            borderRadius: '50%',
            padding: '1.5em',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <SearchOffIcon
            sx={{
              fontSize: '3rem',
              color: theme.palette.grey[600]
            }}
          />
        </Box>

        <Stack spacing={1} alignItems="center" textAlign="center">
          <Typography variant="h5" fontWeight="600" color={theme.palette.text.primary} sx={{ marginBottom: '0.5em' }}>
            No Results Found
          </Typography>
          <Typography variant="body1" color={theme.palette.text.secondary} sx={{ lineHeight: 1.6 }}>
            We couldn't find any items matching your search criteria.
          </Typography>
          <Typography
            variant="body2"
            color={theme.palette.text.secondary}
            sx={{
              fontStyle: 'italic',
              marginTop: '0.5em !important'
            }}>
            Try adjusting your search terms or check for typos
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}
